module.exports = __webpack_public_path__ + "static/media/tracking-device-inactive.5de13dda.svg";